import $ from 'jquery';

import Menu from './modules/menu';
import Carousel from './modules/carousel';
import LightBox from './modules/lightbox';
import Animation from './modules/animation';
import SmoothScroll from './modules/smoothScroll';

window.addEventListener('DOMContentLoaded', function(){
    Menu.run();
    Carousel.run();
    LightBox.run();
    Animation.run();
    SmoothScroll.run();
 });
